(function ($) {
$('.product__media-list').on( 'pointerMove.flickity', listener );
function listener(){
$('.product__media-zoom-lightbox').removeClass('product__media-toggle');
    
}
$('.product__media-list').on( 'dragEnd.flickity', listener1 );
function listener1(){
    $('.product__media-zoom-lightbox').addClass('product__media-toggle');
}

  /*** PDP accordian ***/
  // $(document).on("click",".ajax-data-block .accordion_head",function (e) {    
  //     e.preventDefault(); 
  //     var a = $(this).attr("data-get");
  //   if( a != undefined ){
  //    $.ajax({
  //       type: "GET",
  //       url: $(".page-link").val() + "?view=ajax-product-data",
  //       success: function (data) {
  //         $(".ajax-accordion_body").addClass("active");
  //         $("body").addClass("open_drw_new");
  //         $(".ajax-accordion_body .accordion_body_inner").html($(`#accordion .custom-${a} .accordion_body_inner`, data).html());
  //       },
  //     }); 
      
  //   }
  //   });
  /** without AJAX ***/
   $(document).on("click",".accordion_head",function (e) {    
      e.preventDefault(); 
      var a = $(this).attr("data-get");
    if( a != undefined ){
     $('.accordion_body[data-get="'+a+'"]').addClass('active');
       $("body").addClass("open_drw_new");
     }
    });
   /** without AJAX END HERE***/
if(window.location.href.indexOf('/products') > -1){
    /** FAQ section **/
    $('.main_tab .main_tab_title').click(function(){
    var main_title = $(this).attr('data-tab');
    $('.main_tab .main_tab_title').not($(this)).removeClass('active');
    $(this).addClass('active');
    $(this).parents('.main_faq_container').find('.main_faq_container_sub .main_container_qus_ans').hide();
    $(this).parents('.main_faq_container').find('.main_faq_container_sub .main_container_qus_ans[data-faq-container="'+main_title+'"]').show();
    });
    if($(window).width() < 720){
    $('.main_tab_title.mobile_only').click(function(){
    var _this = this;
    $(this).toggleClass('active');
    var tab_title = $(this).attr('data-tab');
    $(this).parents('.main_faq_container_sub').find('.main_container_qus_ans[data-faq-container="'+tab_title+'"]').toggle();
    });
    }
     $('.tab-main').click(function(){
        $(this).toggleClass('active');
        $(this).next('.col-tab-content').toggle();
        
      });
// Added Show More Show Less START
$('.faq_show_more').click(function(){
	$(this).parents('.main_wrapper').find('.main_container_qus_ans .main_container_qus_ans_sub').show(300);
      	$(this).parents('.main_wrapper').find('.main_container_qus_ans .faq_show_less').show();
	$(this).hide();
});
  $('.faq_show_less').click(function(){
      $(this).parents('.main_wrapper').find('.main_container_qus_ans .main_container_qus_ans_sub:not(.visible_faq)').hide(300);
      	$(this).parents('.main_wrapper').find('.main_container_qus_ans .faq_show_more').show();
	$(this).hide();
});
// Added Show More Show Less END
  
  }
   
    /** FAQ section end**/
  $(document).on("click", ".close_tab", function () {
    $(".accordion_body").removeClass("active");
    $("body").removeClass("open_drw_new");
  });
  $(document).on("click", ".accordion_body", function (a) {
    $(a.target).closest(".accordion_body_inner").length ||
      ($(this).removeClass("active"), $("body").removeClass("open_drw_new"));
  });
  $(".pdp_faq_tab").click(function (a) {
    a.preventDefault(),
      $("html, body").animate(
        { scrollTop: $("#pdp_FAQ_sec").offset().top - 80 },
        1e3
      );
  });

  $(".reviews_tab").click(function (a) {
    a.preventDefault(),
      $("html, body").animate(
        { scrollTop: $("#judgeme_product_reviews").offset().top - 80 },
        1e3
      );
  });
  $(document).on("click", ".static-content-accordian", function (e) {
    e.preventDefault();
    var dataType = $(this).attr("data-get");
    $('.static-accordion_body[data-get="' + dataType + '"]').addClass("active");
    $("body").addClass("open_drw_new");
  });
  /*** PDP accordian END HERE***/
  /** product-as-variant box click **/
$(document).on("click", ".product-as-variant-inner", function (e) {
    e.stopPropagation(); 
    var dropdown = $(this).parents(".product-as-variant-outer").find(".product-as-variant-product-list");
    var isActive = dropdown.is(':visible');
    $(".product-as-variant-product-list").slideUp();
    if (!isActive) {
        dropdown.slideDown();
    }
});

$(document).on("click", function (e) {
    var container = $(".product-as-variant-product-list");
    if (!container.is(e.target) && container.has(e.target).length === 0 && !$(".product-as-variant-inner").is(e.target)) {
        container.slideUp();
    }
});

  /** product-as-variant box click END HERE**/
 
  /*** Change sticky add to cart variant **/
   function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
  if($('.sticky-add-to-cart .swatch-input__input').length >0){
     $(document).on('change','.swatch-input__input',function(){
   var swatch_val=$(this).val();
    if($(this).parents('.grid__item').hasClass('product__info-wrapper')){
       $('.sticky-add-to-cart .swatch-input__input[value="'+swatch_val+'"]').trigger('click');
    }else if($(this).parents('.stick-addtocart-outer').hasClass('sticky-add-to-cart')){
       $('.product__info-wrapper .swatch-input__input[value="'+swatch_val+'"]').trigger('click');
    }
   
});
     
  }
$(document).on("click", ".custom_drop_down .main_title", function(e) {
    e.stopPropagation();  
    var dropdown = $(this).parents('.custom_drop_down').find('.options-selection__input-select-wrapper_custom');
    var isActive = dropdown.is(':visible');
    $(".options-selection__input-select-wrapper_custom").slideUp();
    $(".custom_drop_down .main_title").removeClass('active');
    if (!isActive) {
        dropdown.slideDown();
        $(this).addClass('active');
    }
});

  $(document).on('change', '.swatch-input__input', function() {
   var swatch_val = $(this).val(); 
   var var_id = $('.product-form input[name="id"]').val(); 
  //alert(var_id);
   var selectElement = $('.right_side_content .custom_pdp_select');
   selectElement.find('option').each(function() {
      var optionVarId = $(this).attr('var-id');
      if (optionVarId === var_id) {
         $(this).attr('selected', 'selected');
      } else {
        $(this).removeAttr('selected');
      }
   });
});
  
    var b = null;
     function c(v) {
       var a = $.trim($('.right_side_content .custom_pdp_select option:selected').text()),
             ts = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-top-speed"),
            w = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-weight"),
            r = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-range"),
            hc = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-hill-climb"),
            wr = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-water-resistance"),
            wl = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-rider_weight_limit"),
            s = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-stackable"),
            ac= $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-app_connectivity"),
            mp = $(".variants-meta-data[data-main_title='" + a + "']").attr("compare-max_power"),
            os = $(".variants-meta-data[data-main_title='" + a + "']").attr(" compare-output_sockets");
             if(ts !=''){$(".main-container.top-speed .mf-value").text(ts);}
              if(r !=''){$(".main-container.range .mf-value").text(r);}
             if(w !=''){ $(".main-container.weighs .mf-value").text(w);}
             if(hc !=''){ $(".main-container.climb-angle .mf-value").text(hc);}
            if(wr !=''){ $(".main-container.water-resistance .mf-value").text(wr);}
            if(wl !=''){ $(".main-container.rider-weight-limit .mf-value").text(wl);}
            if(s !=''){ $(".main-container.stackable .mf-value").text(s);}
            if(ac !=''){ $(".main-container.app-connectivity .mf-value").text(ac);}
            if(mp !=''){ $(".main-container.max-power .mf-value").text(mp);}
            if(os !=''){ $(".main-container.output-sockets .mf-value").text(os);}
           
    }
   $(document).on("change", ".swatch-input__input", function () {
     var var_id = $('.right_side_content .product-variant-id').val(); 
   var selectElement = $('.right_side_content .custom_pdp_select');
   selectElement.find('option').each(function() {
      var optionVarId = $(this).attr('var-id');
      if (optionVarId === var_id) {
         $(this).attr('selected', 'selected');
      } else {
        $(this).removeAttr('selected');
      }
   });
       c($(this).attr("value"));
        });
  
    $(document).on("click",".select__selectoption li.selected_option",function() {
        var variantText = $(this).text();
      var variantText = $(this).text();
      // var size_text = $(this).text();
      //     var selected_color = $.trim($('.right_side_content .custom_pdp_select option:selected').text());
      //     var split_colors = selected_color.split('/');
      //     var result = split_colors[0].trim() + " / " + size_text.trim();
      var size_text = $(this).text();
   var selected_color = $.trim($('.right_side_content .custom_pdp_select option:selected').text());
      var result;
      if (!selected_color) {
       var split_colors = selected_color.split('/');
          result = split_colors[0].trim() + " / " + size_text.trim();
      } else {
         result = size_text.trim();;
         
      }
          var selectElement = $('.right_side_content .custom_pdp_select');
             selectElement.find('option').each(function() {
                var selected_variant = $(this).attr('var-title');
                if (selected_variant === result) {
                   $(this).attr('selected', 'selected');
                } else {
                  $(this).removeAttr('selected');
                }
             });
      c($(this).attr("value"));
        $(this).parents('.options-selection__input-select-wrapper_custom').slideToggle();
        var variantid= $(this).attr('selected-variant');     
        $('.options-selection__input-select-wrapper_custom').removeClass('active');
        $('.select__selectoption li.selected_option').removeClass('activeoption');
        $(this).addClass('activeoption');
        var swatch_val=$(this).attr('selected-variant');
        $(this).parents('.custom_drop_down').find('.active_tab_name').text(variantText);
        if($(this).parents('.grid__item').hasClass('product__info-wrapper')){
        $('.sticky-add-to-cart .custom_drop_down .active_tab_name').text(variantText);
        }
        else if($(this).parents('.stick-addtocart-outer').hasClass('sticky-add-to-cart')){
        $('.sticky-add-to-cart .custom_drop_down .active_tab_name').text(variantText);
        }
        $('.select option').removeAttr('selected');
       $('.sticky-add-to-cart .select__select option[variant-value="'+swatch_val+'"]').attr('selected','selected');
       $('.main_product .select__select option[variant-value="'+swatch_val+'"]').attr('selected','selected');
       if($(this).parents('.quick-add-modal__content-info').length > 0){
         $('.quick-add-modal__content-info .select__select option[variant-value="'+swatch_val+'"]').attr('selected','selected');
       } 
      if(window.location.href.indexOf('/products') > -1){
       eventFire(document.getElementById($('.sticky-add-to-cart .select__select').attr('id')), 'change');
      }
      eventFire(document.getElementById($('.product__info-wrapper .select__select').attr('id')), 'change');
      var swrachName = $(this).parents('.custom_drop_down').find('.active_tab_name').attr('data-attr-var');    
      $('.custom_drop_down').find('.active_tab_name[data-attr-var="'+swrachName+'"]').text(variantText);
   
    
  });
   $(document).mouseup(function(e) {
    var dropdown = $(".options-selection__input-select-wrapper_custom");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0 && !$(".main_title").is(e.target)) {
        dropdown.slideUp();
        $(".custom_drop_down .main_title").removeClass('active');
    }
});
    /*** Change sticky add to cart variant END HERE**/ 

   if(window.location.href.indexOf('/products') > -1 && $('.cstm-iframe').length >0){
    $(document).on("click",".youtube_video_image",function() {
    var videoLink = $('.youtube_video_image').attr('vid');  
    //$(this).hide();
    $('#pdp_video1').html(' <iframe  id="pdp_video" src="https://www.youtube.com/embed/'+videoLink+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
  });
  var scrollTriggered = false;
     
$(window).scroll(function(){    
    var bottom = $('.cstm-iframe').offset().top - 52;  
    if ($(this).scrollTop() > bottom && !scrollTriggered){            
        $('.youtube_video_image').trigger('click');
        scrollTriggered = true; 
    }
    else{ }
});
var Intervalclear = setInterval(check_slider,1000)

function check_slider() {
  console.log('interval')
   if($('.main_pdp_image-text .custom_main-slider.flickity-enabled.is-draggable').length > 0 ){
           console.log('clear')
         window.dispatchEvent(new Event('resize'));
       clearInterval(Intervalclear);
   }
}
   }
})(jQuery);
